import React from 'react';

export const DefaultAvatarSvg = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.15">
      <path
        d="M2 46C2 34.954 10.954 26 22 26H26C37.046 26 46 34.954 46 46"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M24 26C30.6274 26 36 20.6274 36 14C36 7.37258 30.6274 2 24 2C17.3726 2 12 7.37258 12 14C12 20.6274 17.3726 26 24 26Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  </svg>
);
